export interface IErrorRoute {
    id: string;
    contentId: string;
    path: string;
}

export const UNEXPECTED_ROUTE = {
    contentId: 'p400',
    id: '400',
    path: '/error/unexpected',
};

export const UNAUTHORISED_ROUTE = {
    contentId: 'p401',
    id: '401',
    path: '/error/unauthorised',
};

export const FORBIDDEN_ROUTE = {
    contentId: 'p403',
    id: '403',
    path: '/error/forbidden',
};

export const NOT_FOUND_ROUTE = {
    contentId: 'p404',
    id: '404',
    path: '/error/not-found',
};

export const SERVICE_UNAVAILABLE = {
    contentId: 'p500',
    id: '500',
    path: '/error/service-unavailable',
};

export const errorRoutes: IErrorRoute[] = [
    UNEXPECTED_ROUTE,
    UNAUTHORISED_ROUTE,
    FORBIDDEN_ROUTE,
    NOT_FOUND_ROUTE,
    SERVICE_UNAVAILABLE,
];
